module.exports = __webpack_public_path__ + "static/Nico-f1049082eb58b4aa84b145a2e5e4e8ed.jpg";